/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { getPayloadObject, getTelemetryAttributes, ITelemetryContent } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

export interface IAdressInput {
    id?: string;
    name?: string;
    className: string;
    type: string;
    value: string;
    maxLength?: number;
    autoFocus?: boolean;
    additionalAddributes?: object;
    telemetryContent?: ITelemetryContent;
    onChange(event: React.ChangeEvent<HTMLInputElement>): void;
}

/**
 * Address input.
 * @param props - Configuration of the functional component.
 * @returns React functional component.
 */
export const AddressInputFunctionComponent: React.FC<IAdressInput> = (props: IAdressInput) => {
    const {
        id: itemId,
        name,
        className,
        type,
        value,
        maxLength,
        additionalAddributes,
        autoFocus: shouldUseAutoFocus,
        telemetryContent,
        onChange
    } = props;

    const payLoad = getPayloadObject('click', telemetryContent!, name!);
    const attributes = getTelemetryAttributes(telemetryContent!, payLoad);
    let placeholder = name;
    if (name === 'Name') {
        placeholder = `${name} *`;
    }
    if (name === 'Name') {
        placeholder = `${name} *`;
    }
    if (name === 'Street') {
        placeholder = `Start typing your address...`;
    }
    if (name === 'City') {
        placeholder = `${name} *`;
    }
    if (name === 'ZipCode') {
        placeholder = `Postcode *`;
    }
    const isPhone = name ? name.toLowerCase() === 'phone' : undefined;
    if (isPhone) {
        placeholder = `Phone *`;
    }
    return (
        <input
            name={name}
            id={itemId}
            className={`${className}__input ${className}__input-${type}`}
            type={isPhone ? 'number' : type}
            autoFocus={shouldUseAutoFocus}
            value={value}
            maxLength={maxLength}
            {...(additionalAddributes || {})}
            {...attributes}
            onChange={onChange}
            placeholder={placeholder}
            inputMode={isPhone ? 'tel' : 'text'}
        />
    );
};

export default AddressInputFunctionComponent;
